/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

/**
 * Lightweight event bus for trade-approval changes.
 *
 * Any component that mutates approval state (approve / reject) or receives
 * a new TRADE_APPROVAL notification via WS should call `emitTradeApprovalChange()`.
 *
 * Consumers (Sidebar badge, PendingTradesPage list) listen with
 * `window.addEventListener(TRADE_APPROVAL_CHANGED, handler)`.
 */

export const TRADE_APPROVAL_CHANGED = 'trade-approval-changed';

export function emitTradeApprovalChange() {
  window.dispatchEvent(new CustomEvent(TRADE_APPROVAL_CHANGED));
}
